module.exports = __webpack_public_path__ + "media/images/icons/upicon-353badbabceb0159df60e90fb945d57d.svg";